import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { AppService } from '@suite/app.service';
import { DraggableEnpsComponent } from '@suite/common/components/base/draggable-enps-component';

@Component({
    selector: 'st-expansion-panel',
    templateUrl: './st-expansion-panel.component.html',
    styleUrls: ['./st-expansion-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-expansion-panel',
    },
})
export class StExpansionPanelComponent extends DraggableEnpsComponent {
    @Output() panelStateChanged = new EventEmitter<boolean>();

    @Input() togglePosition: 'before' | 'after' = 'before';

    @Input()
    get expanded(): boolean {
        return this._expanded;
    }
    set expanded(expanded: BooleanInput) {
        expanded = coerceBooleanProperty(expanded);

        if (this._expanded !== expanded) {
            this._expanded = expanded;
            this.changeDetectorRef.markForCheck();
        }
    }
    private _expanded = false;

    @Input()
    get hideToggle(): boolean {
        return this._hideToggle;
    }
    set hideToggle(show: BooleanInput) {
        this._hideToggle = coerceBooleanProperty(show);
    }
    private _hideToggle: boolean = false;

    @Input()
    get inEditMode(): boolean {
        return this._inEditMode;
    }
    set inEditMode(value: BooleanInput) {
        this._inEditMode = coerceBooleanProperty(value);
    }
    private _inEditMode: boolean = false;

    constructor(
        public appService: AppService,
        private ngZone: NgZone,
        private changeDetectorRef: ChangeDetectorRef,
        private renderer: Renderer2,
        public globalTablesService: GlobalTablesService,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService
    ) {
        super();
    }

    panelOpened() {
        this.expanded = true;
        this.panelStateChanged.emit(true);
    }

    panelClosed() {
        this.expanded = false;
        this.panelStateChanged.emit(false);
    }
}
